import { render, staticRenderFns } from "./PoiMiniCardThumbnail.vue?vue&type=template&id=785a6606&"
import script from "./PoiMiniCardThumbnail.vue?vue&type=script&lang=ts&"
export * from "./PoiMiniCardThumbnail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports